
const engine = {
  // Titan Engine
  engine: {
    title: "Titan Engine",
    heroTitle: "AI-Powered Sports Predictions",
    heroDescription: "Experience the next generation of sports betting intelligence with our advanced machine learning algorithms that analyze millions of data points to deliver precise predictions.",
    accuracy: "87% Accuracy",
    analyzed: "1M+ Matches Analyzed",
    realtime: "Real-time Analysis",
    selectLeague: "Select a League",
    selectLeagueTitle: "Available Leagues",
    selectDescription: "Choose a league to view detailed predictions and analysis powered by our AI engine.",
    searchLeague: "Search leagues...",
    league: "League",
    type: "Type",
    currentRound: "Current Round",
    season: "Season",
    noLeaguesFound: "No leagues found",
    noLeaguesSearch: "No leagues found matching your search",
    features: "Key Features",
    featureAI: "Advanced AI",
    featureAIDesc: "Machine learning algorithms trained on millions of historical matches and real-time data.",
    featurePredictions: "Smart Predictions",
    featurePredictionsDesc: "Comprehensive analysis covering match outcomes, goals, and statistical probabilities.",
    featureTrends: "Trend Analysis",
    featureTrendsDesc: "Identify patterns and trends that influence match outcomes and betting opportunities.",
    featureProcessing: "Real-time Processing",
    featureProcessingDesc: "Instant analysis of live data including team news, weather, and market movements.",
    featureHistory: "Historical Performance",
    featureHistoryDesc: "Track record of predictions with detailed performance metrics and accuracy rates.",
    featureStats: "Advanced Statistics",
    featureStatsDesc: "In-depth statistical analysis and visualizations for informed decision making.",
    performance: "Performance Metrics",
    overallAccuracy: "Overall Accuracy",
    avgROI: "Average ROI",
    predictionsGenerated: "Predictions Generated",
    dataUpdated: "Data Updated",
    updateFailed: "Update Failed",
    errorAPI: "Error connecting to API",
    error: "Error",
    marketOddsAnalysis: "Market Odds Analysis",
    statisticalModel: "Statistical Model",
    bettingRecommendations: "Betting Recommendations",
    mainMarket: "Main Market",
    draw: "Draw",
    home: "Home",
    away: "Away",
    probability: "probability",
    modelRecommendation: "Model Recommendation",
    betOn: "Bet on",
    withOdds: "with odds",
    noRecommendations: "No Strong Recommendations",
    noValueBets: "No significant value bets detected for this match",
    withOdd: "with odd",
    noSignificantValueBets: "No significant value bets found for this match"
  }
};

export default engine;
